const marketingRoutes = [
  {
    path: '/activity-page',
    name: 'ActivityPage',
    meta: {
      index: 8
    },
    component: () => import('@/views/marketing/activityPage/Index.vue')
  },
  {
    path: '/newborn',
    name: 'Newborn',
    meta: {
      index: 8
    },
    component: () => import('@/views/marketing/newCustomers/Index.vue')
  },
  {
    path: '/coupon',
    name: 'Coupon',
    meta: {
      index: 8
    },
    component: () => import('@/views/marketing/coupon/Index.vue')
  }
]
export default marketingRoutes
